export enum SignalTypes {
  NOTIFICATION = 'notification',
  SETTINGS_UPDATE = 'settings_update',
  BACKGROUND_TASK_STATE = "background_task_state",
  /** JT1-1767: the AI finished reviewing a note this account saved. */
  AI_NOTE_REVIEWED = "ai_note_reviewed",
}
